<button
    (click)="handleBack()"
    class="border border-gray-300 rounded-md px-2 py-1 flex gap-2 items-center justify-center w-max hover:bg-gray-50 transition-colors"
>
    <app-icon name="bx:bxs-door-open" class="text-gray-600" />
    <p class="text-sm">나가기</p>
</button>
